import { useMemo } from 'react';
import Dandelion from '@alltrails/shared/illustrations/Dandelion';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import * as styles from './styles/styles.module.scss';
import { defineMessages } from '@alltrails/shared/react-intl';

const TRAIL_FORM_SUCCESS_STRINGS = defineMessages({
  THANKS_FOR_REVIEW: {
    defaultMessage: 'Thanks for sharing'
  },
  COMMUNITY_RELIES: {
    defaultMessage: 'Reviews like yours help people every day to feel confident on the trail.'
  },
  PHOTOS_UPLOADED: {
    defaultMessage: 'Photos uploaded'
  },
  YOURE_HELPING: {
    defaultMessage: 'You’re helping the community preview trails.'
  },
  KEEP_SNAPPING_SHARING: {
    defaultMessage: 'Keep snapping and sharing!'
  },
  KEEP_EM_COMING: {
    defaultMessage: 'Keep them coming!'
  },
  RECORDING_UPLOADED: {
    defaultMessage: 'Activity uploaded'
  },
  FIND_NEW_ROUTES: {
    defaultMessage: "You're helping the community find new routes."
  },
  KEEP_EXPLORING: {
    defaultMessage: 'Keep exploring!'
  },
  ROUTE_UPLOADED: {
    defaultMessage: 'Route uploaded'
  },
  ROUTE_ADDED: {
    defaultMessage: 'Route has been added to your map.'
  },
  KEEP_CREATING: {
    defaultMessage: 'Keep creating!'
  }
});

export type TrailFormSuccessProps = {
  variant: 'review' | 'photo' | 'track' | 'route';
};

const TrailFormSuccess = ({ variant }: TrailFormSuccessProps) => {
  const {
    formattedDefaultMessages: {
      THANKS_FOR_REVIEW,
      COMMUNITY_RELIES,
      PHOTOS_UPLOADED,
      YOURE_HELPING,
      KEEP_SNAPPING_SHARING,
      KEEP_EM_COMING,
      RECORDING_UPLOADED,
      FIND_NEW_ROUTES,
      KEEP_EXPLORING,
      ROUTE_UPLOADED,
      ROUTE_ADDED,
      KEEP_CREATING
    }
  } = useFormatMessage(TRAIL_FORM_SUCCESS_STRINGS);

  const variants = useMemo(
    () => ({
      review: {
        heading: THANKS_FOR_REVIEW,
        subTextFirst: COMMUNITY_RELIES,
        subTextSecond: KEEP_EM_COMING
      },
      photo: {
        heading: PHOTOS_UPLOADED,
        subTextFirst: YOURE_HELPING,
        subTextSecond: KEEP_SNAPPING_SHARING
      },
      track: {
        heading: RECORDING_UPLOADED,
        subTextFirst: FIND_NEW_ROUTES,
        subTextSecond: KEEP_EXPLORING
      },
      route: {
        heading: ROUTE_UPLOADED,
        subTextFirst: ROUTE_ADDED,
        subTextSecond: KEEP_CREATING
      }
    }),
    []
  );

  const { heading, subTextFirst, subTextSecond } = variants[variant];

  return (
    <div className={styles.container}>
      <div>
        <Dandelion size="lg" />
        <h3 className={styles.headingText}>{heading}</h3>
        <p className={styles.subText}>
          {subTextFirst} {subTextSecond}
        </p>
      </div>
    </div>
  );
};

export default TrailFormSuccess;
